import { EllipsisText } from "@components/ellipsis-text";
import { Modal } from "@components/modal";
import { Config, DoubleText, Table } from "@components/table";
import {
  AdminPayoutHistory,
  AdminPayOutOrder,
} from "@features/admin/payOut/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatUsdt } from "@helpers/format";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  data: AdminPayOutOrder;
};
const config: Config<AdminPayoutHistory> = [
  {
    label: "Назначена на трейдера",
    source: "assigned_to_trader_time_unix",
    renderComponent: (data) => (
      <DoubleText
        text={formatTime(new Date(data * 1000))}
        subText={formatDate(new Date(data * 1000))}
      />
    ),
  },
  {
    label: "ID трейдера",
    source: "trader_email",
    renderComponent: (data) => <EllipsisText text={data} copy />,
  },
  {
    label: "ID тимлид",
    source: "team_lead",
    renderComponent: (data) => <EllipsisText text={data} copy />,
  },
  {
    label: "Сумма",
    source: "sum_usdt",
    renderComponent: (data) => <>{formatUsdt(data)}</>,
  },
  {
    label: "Заработок трейдера",
    source: "trader_ern_usdt",
    renderComponent: (data) => <>{formatUsdt(data)}</>,
  },
  {
    label: "Комиссия трейдера",
    source: "trader_commission",
  },
  {
    label: "Комиссия тимлида",
    source: "team_lead_commission_pay_out",
  },
  {
    label: "Заработок тимлида",
    source: "team_lead_ern_usdt",
    renderComponent: (data) => <>{formatUsdt(data)}</>,
  },
  {
    label: "Наш заработок",
    source: "our_ern_usdt",
    renderComponent: (data) => <>{formatUsdt(data)}</>,
  },
  {
    label: "Наша комиссия",
    source: "our_commission",
  },
  {
    label: "Затраты мерча",
    source: "merchant_spend_usdt",
    renderComponent: (data) => <>{formatUsdt(data)}</>,
  },
  {
    label: "Дата отмены",
    source: "cancelled_at",
    renderComponent: (data) =>
      data && (
        <DoubleText
          text={formatTime(new Date(data))}
          subText={formatDate(new Date(data))}
        />
      ),
  },
  {
    label: "Сообщение отмены",
    source: "cancel_comment",
  },
  {
    label: "Файлы отмены",
    source: "cancel_images",
    renderComponent: (data) => (
      <>{data?.map((url) => <EllipsisText text={url} link={url} />)}</>
    ),
  },
];
export const HistoryModal = ({ hideModal, isModalOpen, data }: Props) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title={"История вывода"}
      // className={styles.modal}
    >
      <Table
        config={config}
        data={data.trader_history}
        emptyText="Нет истории"
      ></Table>
    </Modal>
  );
};
